// import barba from '@barba/core';
import lazySizes from 'lazysizes';
import Lenis from '@studio-freight/lenis';
import imagesLoaded from 'imagesLoaded';
import gsap from "gsap/all";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import Swiper from 'swiper';
import { Fancybox } from "@fancyapps/ui";
import { Cursor } from "./cursor";
import Navigation from "./navigation";
// import { ImageHover } from './image-hover';

const cursor = new Cursor(document.querySelector(".cursor"));
const drawerBtn = document.getElementById('drawerBtn');
const page = document.getElementById('page');

const drawer_tl = gsap.timeline({paused: true});


[...document.querySelectorAll('a')].forEach(link => {
    link.addEventListener('mouseenter', () => cursor.enter());
    link.addEventListener('mouseleave', () => cursor.leave());
});


const lenis = new Lenis({
  duration: 1.2,
  easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
  gestureOrientation: 'both', // vertical, horizontal
  smoothWheel: true,
  wheelMultiplier: 1,
  smoothTouch: false,
  touchMultiplier: 2,
  infinite: false,
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

requestAnimationFrame(raf)

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);
lazySizes.init();

drawer_tl.to('#drawer', {
  y: 0,
  autoAlpha: 1,
  duration: 0.6
});

drawerBtn.addEventListener('click', function(e) {
  e.preventDefault();
  e.stopPropagation();
  if (e.target.classList.contains('is-open')) {
    e.target.classList.remove('is-open');
    drawer_tl.reverse();
  } else {
    e.target.classList.add('is-open');
    drawer_tl.play();
  }
});

// Preload images
const preloadImages = () => {
    return new Promise((resolve, reject) => {
        imagesLoaded(document.querySelectorAll('#drawer .screen'), {background: true}, resolve);
    });
};

Promise.all([preloadImages()]).then(() => {
    new Navigation(document.querySelector('#drawer .screens-wrapper'));
    new Navigation(document.querySelector('#overview .screens-wrapper'));
    document.body.classList.remove('loading');
});

/*preloadImages('[data-repetition]').then(() => {
    [...document.querySelectorAll('.card-img-top')].forEach(el => new ImageHover(el));
});
*/


function createSwipers() {
  const sliders = document.querySelectorAll('.swiper'); 
  [].forEach.call(sliders, function(slider) {
    var itemsPerRow = slider.getAttribute('data-items');
    const swiper = new Swiper(slider, {
      loop: true,
      slidesPerView: itemsPerRow,
      spaceBetween: 10,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      scrollbar: {
        el: slider.querySelector('.swiper-scrollbar'),
      },
      autoplay: true,
    });

  });    
}


Fancybox.bind('[data-fancybox="gallery"]', {
  wheel: "slide",
  protected: true, 
  Panzoom: {
    click: "iterateZoom"
  }
});


createSwipers();